import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Collapse,
  IconButton,
  Button,
} from '@mui/material';
import { ExpandMore, ExpandLess, OpenInNew } from '@mui/icons-material';

export default function EditorHeader({ classification, totalPages, pageOffset, onBack }) {
  const [expanded, setExpanded] = useState(false);

  const metadata = classification?.document?.metadata;
  const authors = metadata?.copyright_holders?.authors || [];
  const impressionId = metadata?.impression_id;

  const getTmmUrl = () => {
    if (!impressionId) return null;
    return `http://192.168.135.68:8281/tmm/tenants/prod/#/productDetail/PRD/transcript%20Standard/${impressionId}/D/952/`;
  };

  const tmmUrl = getTmmUrl();

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 0,
        zIndex: 10,
      }}
    >
      {/* Compact header - always visible */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, minWidth: 0 }}>
          <IconButton
            size="small"
            onClick={() => setExpanded(!expanded)}
            sx={{ flexShrink: 0 }}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {metadata?.title || classification?.filename}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block' }}
            >
              {classification.filename} • {totalPages} pages • Offset: {pageOffset}
            </Typography>
          </Box>
        </Box>

        {tmmUrl && (
          <Button
            variant="outlined"
            endIcon={<OpenInNew />}
            href={tmmUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ flexShrink: 0 }}
          >
            Open in TLM
          </Button>
        )}
      </Box>

      {/* Expandable details */}
      <Collapse in={expanded}>
        <Box sx={{ px: 3, pb: 2, pt: 0 }}>
          {metadata?.subtitle && (
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {metadata.subtitle}
            </Typography>
          )}
          
          {authors.length > 0 && (
            <Box sx={{ mt: 1 }}>
              {authors.map((author, index) => (
                <Typography key={index} variant="body2" color="text.secondary">
                  {author.prefix && `${author.prefix} `}
                  {author.first_name} {author.last_name}
                  {author.orcid && ` (ORCID: ${author.orcid})`}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      </Collapse>
    </Paper>
  );
}